module.exports = __webpack_public_path__ + "img/umd.2f6109f4.jpg";